import styled from '@emotion/styled'
import { Stack } from 'components/Stack'
import { pxToRem, BREAKPOINTS } from 'utils/styled'

export const SContainer = styled(Stack)`
  padding-top: ${pxToRem(150)}rem;
  padding-bottom: ${pxToRem(145)}rem;

  @media ${BREAKPOINTS.LG.max} {
    padding-top: ${pxToRem(20)}rem;
    padding-bottom: ${pxToRem(60)}rem;
    flex-direction: column;

    position: relative;
  }
`

export const SImageContainer = styled.div`
  display: flex;
  align-items: center;

  @media ${BREAKPOINTS.LG.max} {
    margin-bottom: ${pxToRem(30)}rem;
  }
`

export const SContentContainer = styled(Stack)`
  position: relative;
  justify-content: center;
  padding-right: ${pxToRem(55)}rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: -${pxToRem(55)}rem;
    left: -${pxToRem(300)}rem;
    bottom: -${pxToRem(55)}rem;
    right: 0;
  }

  @media ${BREAKPOINTS.LG.max} {
    padding-right: ${pxToRem(0)}rem;
  }
`
export const SAuthorContainer = styled(Stack)`
  align-items: center;

  @media ${BREAKPOINTS.MD.max} {
    flex-direction: column;
    align-items: flex-start;

    & > *:not(:last-child) {
      margin-bottom: 1rem;
      margin-right: 0;
    }
  }
`

export const SAmazonContainer = styled(Stack)`
  align-items: center;
  @media ${BREAKPOINTS.MD.max} {
    align-items: flex-start;
    flex-direction: column;

    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: ${pxToRem(16)}rem;
    }
  }
`
